export class Summary {
	get prices(): Map<number, number> {
		return this._prices;
	}
	private _prices: Map<number, number> = new Map();
	private total: number = 0.0;
	private discount: number = 0;

	public constructor() {
		this.update();
	}

	async refresh() {
		const elem = document.querySelector<HTMLElement>('.discount[data-discount]');
		if (elem) {
			this.discount = parseInt(elem.dataset.discount);
			console.log(this.discount);
		}
		const equipmentTable = document.querySelector<HTMLElement>('.equipment-select[data-plot-price][data-base-price]');
		if (equipmentTable) {
			this.plotPrice = parseInt(equipmentTable.dataset.plotPrice);
			this.basePrice = parseInt(equipmentTable.dataset.basePrice);
		}
		const inputs = document.querySelectorAll<HTMLInputElement>('input.equipment-select:checked');
		for (const input of inputs) {
			this.setPrice(parseInt(input.dataset.id), parseInt(input.value));
		}
		console.log(inputs, this._prices);
		this.update();
	}

	private _plotPrice: number = 0.0;

	set plotPrice(value: number) {
		console.log('plotPrice', value);
		this._plotPrice = value;
	}

	private _basePrice: number = 0.0;

	set basePrice(value: number) {
		console.log('basePrice', value);
		this._basePrice = value;
	}

	public clearPrices() {
		this._prices.clear();
		return this;
	}

	public update() {
		this.sumTotal();
		return this;
	}

	public setPrices(prices: { [index: number]: number }) {
		Object.entries(prices).forEach(([id, price]) => {
			this._prices.set(parseInt(id), price);
		});
		return this;
	}

	public setPrice(id: number, price: number) {
		this._prices.set(id, price);
		return this;
	}

	public getHistoryParamsObject(): { [index: string]: number|string } {
		let params: { [index: string]: number|string } = Object.fromEntries(new URLSearchParams(window.location.search));
		this._prices.forEach((value, key) => {
			params[`e${key}`] = value;
		});
		return params;
	}

	public getHistoryParams(): string {
		let params = '';
		this._prices.forEach((value, key) => {
			params += `&e${key}=${value}`;
		});
		return params;
	}

	private sumTotal(): number {
		this.total = this._plotPrice + this._basePrice;
		this._prices.forEach(price => {
			this.total += price;
		});
		if (this.discount > 0) {
			this.total -= this.discount;
		}

		for (const totalWrapper of document.querySelectorAll<HTMLElement>('.total-value')) {
			totalWrapper.innerText = this.total.toLocaleString(undefined, {style: 'currency', currency: 'CZK', maximumFractionDigits: 0});
		}

		return this.total;
	}

}
